/* eslint semi:0 */
import React from 'react'
import MatchWithResult from './matchWithResult'
import Team from './team'
import { MATCH_STATUSES, } from '../matchTransformUtil'
import MatchDateScores from './matchDateScores'


const { UPCOMING: UPCOMING_MATCH, } = MATCH_STATUSES
const blockName = 'match-container-component'


export default function MatchItemScores({
  homeTeam, awayTeam, result, date, status: matchStatus,
}){
  const isStarted = matchStatus !== UPCOMING_MATCH
  return (
    <div className={ blockName }>
      <div className={ `${ blockName }__teams-container` }>
        <Team
          name={ homeTeam.name }
          image={ homeTeam.image }
          isHome = { true }
        />
          { isStarted ?
            <MatchWithResult result={ result } /> :
            <MatchDateScores date={ date } />
          }
        <Team
          name={ awayTeam.name }
          image={ awayTeam.image }
          isHome = { false }
        />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/matchItemScores.js